module.exports = __webpack_public_path__ + "static/media/battles-grand-reward-popup.d214f1c6.png";